import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpLazyLoad from 'i18next-http-backend';
import { Language } from './i18.constant';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(HttpLazyLoad)
  .use(initReactI18next)
  .init({
    fallbackLng: Language.az,
    supportedLngs: [Language.az],
    // Language.ru, Language.en],  diller elave edilenden sonra elave et
    interpolation: { escapeValue: false },
    detection: {
      order: ['customPath', 'localStorage', 'querystring', 'navigator', 'path'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
    },
    backend: {
      loadPath: '/locales/az.json',
      // '{{lng}}.json',   diller elave edilenden sonra elave et
      allowMultiLoading: false,
      crossDomain: false,
      withCredentials: false,
      reloadInterval: false,
    },
  });

export default i18n;
